import { render, staticRenderFns } from "./ModalDeleteCompany.vue?vue&type=template&id=f8227fbe"
import script from "./ModalDeleteCompany.vue?vue&type=script&lang=js"
export * from "./ModalDeleteCompany.vue?vue&type=script&lang=js"
import style0 from "./ModalDeleteCompany.vue?vue&type=style&index=0&id=f8227fbe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports